import { isEmpty } from '@/helpers/string.helpers'
import { ChatModel } from '@/models/chat.model'
import { MessageModel } from '@/models/message.model'
import { findUserById, FindUserByIdResponse, updateOnFirebase } from '../_http/user'
import { setControlChange } from '../_http/chat'

export function updateOperator(
  operators: ChatModel['operators'] = [],
  operator: MessageModel['operator']
): ChatModel['operators'] {
  if (isEmpty(operator)) return []
  if (!operators?.length) return [{ id: operator.id, name: operator.name, department: operator.department }]
  const operatorExists = operators?.find(_operator => _operator.id === operator.id)
  return operatorExists ? operators : [operator, ...operators]
}

export function updateOperatorsId(operatorsId: string[] = [], newOperatorId: string): string[] {
  if (!newOperatorId) return operatorsId
  if (!operatorsId) return [newOperatorId]
  return operatorsId?.includes(newOperatorId) ? operatorsId : [newOperatorId, ...operatorsId]
}

export function* handleChangesWhenChatIsOpenAtFirst(chat: ChatModel, operatorId: string) {
  yield setControlChange(chat)
  // TODO: refactor this
  const { user }: FindUserByIdResponse = yield findUserById(operatorId)
  const hasAttendCampaign = user?.attendFor?.find(campaignId => campaignId === chat.campaignId)
  if (hasAttendCampaign) return
  const updatedAttendFor = user?.attendFor?.length ? [...user.attendFor, chat.campaignId] : [chat.campaignId]
  yield updateOnFirebase(user.id, { attendFor: updatedAttendFor })
}
